import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';
import { SsoUserService } from '../../../auth/sso-user.service';

@Injectable({
  providedIn: 'root'
})
export class SsoAuthGuard implements CanActivate {
  constructor(
    protected router: Router,
    private oidcSecurityService: OidcSecurityService,
    private userService: SsoUserService,
    private permissionsService: NgxPermissionsService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (window.location.pathname.includes('/logout')) {
      return new Promise((resolve) => {
        this.oidcSecurityService.logoffAndRevokeTokens().subscribe(() => {
          localStorage.clear();
          this.permissionsService.flushPermissions();
          this.oidcSecurityService.logoffLocal();
          resolve(false);
        });
      });
    }

    if (this.userService.isAuthenticated) {
      return true;
    }

    return new Promise((resolve) => {
      this.oidcSecurityService.checkAuth().subscribe({
        next: (res) => {
          this.userService.isAuthenticated = res.isAuthenticated;

          if (res.isAuthenticated) {
            const redirectUrl = localStorage.getItem('redirect_url');

            if (redirectUrl) {
              localStorage.removeItem('redirect_url');
              window.location.href = redirectUrl;
              resolve(false); 
            } else {
              resolve(true); 
            }
          } else {
            localStorage.setItem('redirect_url', window.location.href);
            this.oidcSecurityService.authorize();
            resolve(false);
          }
        },
        error: (err) => {
          console.warn('OIDC Auth Error, forcing re-login:', err);

          localStorage.setItem('redirect_url', window.location.href);
          this.oidcSecurityService.authorize();
          resolve(false);
        }
      });
    });
  }
}